// src/components/AccordionItem.js

import React, { useState } from 'react';
import './FAQ.css'; // Shared CSS

const AccordionItem = ({ question, answer }) => {
  // Local state to manage whether this specific item is open
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
      {/* Question Header (The clickable part) */}
      <button 
        className="accordion-header" 
        onClick={toggleOpen}
        aria-expanded={isOpen}
        aria-controls={`accordion-answer-${question.replace(/\s/g, '-')}`}
      >
        <span className="question-text">{question}</span>
        {/* Simple "+" or "−" visual indicator */}
        <span className="toggle-icon">{isOpen ? '−' : '+'}</span>
      </button>

      {/* Answer Body (The collapsing part) */}
      <div 
        id={`accordion-answer-${question.replace(/\s/g, '-')}`}
        className="accordion-collapse" 
        style={{ maxHeight: isOpen ? '500px' : '0' }} // Simple collapse transition via max-height
      >
        <div className="accordion-body">
          {answer}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;